<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 py-2 border-b flex items-center">
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="property" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div *ngIf="!changeTitleMode" class="font-bold text-md text-secondary uppercase tracking-wider">
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto" *ngIf="canEditPanelDef">
      <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
        <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
      </button>
      <mat-menu #listCard09Menu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
      </mat-menu>
      <button
        class="cancel-button"
        mat-icon-button
        type="button"
        *ngIf="changeTitleMode"
        [matTooltip]="'Cancel'"
        (click)="cancelEdits()"
      >
        <mat-icon [svgIcon]="'cancel'"></mat-icon>
      </button>

      <!-- Save button -->
      <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon [svgIcon]="'save'"></mat-icon>
      </button>
    </div>
  </div>
  <comment-view [relatedToId]="property.id" relatedToType="Property" [account]="account"></comment-view>
</div>
